
/**
 * Retrieves the culture value from the meta tag in the document head.
 * @returns {string} The culture value or a default culture (e.g., "sv-SE").
 */
export function getPageCulture() {
  return document.querySelector('meta[name="culture"]')?.getAttribute('content') || 'sv-SE';
}
